module.exports = __webpack_public_path__ + "img/icon-info.f59486bc.svg";